export default "__VITE_ASSET__Cq6P$GtW__"